import { useState } from "react";
import { t } from "../i18n";
import { useNavigate } from "react-router-dom";
import { Download, Trash2, Info } from "lucide-react";
import { toast } from "sonner";
import { api, errorMessage, setToken, setUnlockToken } from "../lib/api";
import { Sheet } from "./Sheet";

export function DataSection() {
  const navigate = useNavigate();
  const [modo, setModo] = useState(null);
  const [pwd, setPwd] = useState("");
  const [conf, setConf] = useState("");
  const [busy, setBusy] = useState(false);

  const exportar = async (e) => {
    e.preventDefault(); setBusy(true);
    try {
      const res = await api.post("/export", { password: pwd }, { responseType: "blob" });
      const url = URL.createObjectURL(res.data);
      const a = document.createElement("a"); a.href = url;
      a.download = (res.headers["content-disposition"] || "").match(/filename=([^;]+)/)?.[1] || "circulo-export.zip";
      a.click(); URL.revokeObjectURL(url);
      toast.success(t("data.exported")); setModo(null); setPwd("");
    } catch (err) { toast.error(err.response?.status === 401 ? t("common.wrongPassword") : errorMessage(err)); } finally { setBusy(false); }
  };

  const borrar = async (e) => {
    e.preventDefault(); setBusy(true);
    try {
      await api.post("/account/delete", { password: pwd, confirmacion: conf });
      setToken(null); setUnlockToken(null);
      window.location.href = "/login?msg=eliminada";
    } catch (err) { toast.error(errorMessage(err)); setBusy(false); }
  };

  return (
    <>
      <button data-testid="export-all-btn" onClick={() => { setModo("export"); setPwd(""); }} className="btn-ghost w-full text-sm flex items-center justify-center gap-2"><Download size={16} /> {t("data.export")}</button>
      <button data-testid="delete-account-btn" onClick={() => { setModo("delete"); setPwd(""); setConf(""); }} className="btn-ghost w-full text-sm text-[#f43f5e] border-[#f43f5e]/30 flex items-center justify-center gap-2"><Trash2 size={16} /> {t("data.deleteAccount")}</button>
      <button data-testid="about-link" onClick={() => navigate("/acerca")} className="btn-ghost w-full text-sm flex items-center justify-center gap-2"><Info size={16} /> {t("about.title")}</button>

      <Sheet open={modo === "export"} onClose={() => setModo(null)} title={t("data.export")} testId="export-sheet">
        <form onSubmit={exportar} className="space-y-3">
          <p className="text-sm text-muted-foreground">{t("data.exportDesc")}</p>
          <input data-testid="export-password" className="field" type="password" placeholder={t("common.password")} required value={pwd} onChange={(e) => setPwd(e.target.value)} />
          <button data-testid="export-confirm-btn" className="btn-primary" disabled={busy}>{busy ? t("data.generating") : t("data.download")}</button>
        </form>
      </Sheet>

      <Sheet open={modo === "delete"} onClose={() => setModo(null)} title={t("data.deleteAccount")} testId="delete-sheet">
        <form onSubmit={borrar} className="space-y-3">
          <div className="rounded-xl border border-[#f43f5e]/50 bg-[#f43f5e]/10 p-3 text-sm text-[#fb7185]">{t("data.deleteWarn")}</div>
          <input data-testid="delete-password" className="field" type="password" placeholder={t("common.password")} required value={pwd} onChange={(e) => setPwd(e.target.value)} />
          <input data-testid="delete-confirm-text" className="field" placeholder={t("data.typeDelete")} required value={conf} onChange={(e) => setConf(e.target.value)} />
          <button data-testid="delete-confirm-btn" disabled={busy || conf !== t("data.deleteWord")} className="w-full rounded-full bg-[#f43f5e] text-white font-semibold py-3.5 disabled:opacity-40">{busy ? t("data.deleting") : t("data.deleteMine")}</button>
        </form>
      </Sheet>
    </>
  );
}
